export enum RegistrationConfirmationRoutes {
  RegistrationConfirmation = '/registration-confirmation',
}
